export enum ParticipantsClearedNotificationDataHooks {
  MESSAGE = 'participants-cleared-message',
}
